import notifications from 'shared/childupp-notifications';
import storage from 'shared/childupp-local-storage';
import { determinePlatform, Platform } from 'shared/engine-dynamic';

(function (upp, $) {
    'use strict';

    upp.controller('upp.MainCtrl', [
        '$scope',
        '$rootScope',
        '$location',
        '$window',
        '$q',
        'translator',
        'analytics',
        'config',
        'notificationsService',
        'appi',
        '$interval',
        '$timeout',
        'umetadataService',
        'childuppRuntime',
        function ($scope, $rootScope,  $location, $window, $q, translator, analytics, config, notificationsService, appi, $interval, $timeout, umetadataService, childuppRuntime) {
            var childuppInactive = false,
                $wrapper = $('#content-wrapper'),
                $mainContainer = $('#main-container'),
                $body = $(document.body),
                $bg = $('#app-background');

            /**
             * FUNCTIONS
             */

            /**
             * Should be called when the user has changed the app language
             *
             * @param {String} lang Language code
             * @method changeLanguage
             */
            var changeLanguage = function (lang) {
                if (lang) {
                    translator.setLang(lang);
                }
            };

            /**
             * Should be called when a page is loading, for example, to hide the content with a modal spin
             *
             * @method showPageLoadingMsg
             */
            var showPageLoadingMsg = function () {
                //Sometimes, 'showPageLoadingMsg' calling arrives before the declaration (fe.:testing directive 'uppModalSpin')
                if ($rootScope.showLoading) {
                    $rootScope.showLoading();
                }
            };

            /**
             * Should be called when the page is ready (data fetched), for example, to show the content and hide the modal spin
             *
             * @method hidePageLoadingMsg
             */
            var hidePageLoadingMsg = function () {
                if ($rootScope.hideLoading) {
                    $rootScope.hideLoading();
                }
            };

            /**
             * Shows an inline message indicating a network error
             *
             * @method showNetworkError
             */
            var showNetworkError = function () {
                hidePageLoadingMsg();
                showInlineError({
                    desc: "NETWORK_ERROR"
                });
            };

            var _showError = function (params, fullPageError) {
                if (!childuppInactive) {
                    $scope.error = params;
                    $scope.error.full = fullPageError;

                    if (params.code === 123) {
                        $scope.error.expired = true;
                    }
                }
            };

            /**
             * Shows an inline error message (menu & content is visible)
             *
             * @param {Object} params Message of the error
             * @method showInlineMessage
             */
            var showInlineError = function (params) {
                _showError(params, false);
            };

            /**
             * Shows a full page error message (menu & content is not visible)
             *
             * @param {Object} params Message of the error
             * @method showFullError
             */
            var showFullError = function (params) {
                _showError(params, true);
            };

            /**
             * set the background as white
             */
            var setDefaultBackground = function () {
                var contentsBg = {'background': '#fafafa'};
                $wrapper.css(contentsBg);
                $mainContainer.css(contentsBg);
                $body.css(contentsBg);
                $bg.css(contentsBg);
                $body.removeClass('with-background');
            };

            /**
             * Show a popup when you enter the page that there are unread notifications if you want to read them
             */
            var showNotificationsPopup = function () {
                appi.ui.modalMessage({
                    title: 'NOTIFICATIONS.POPUP.TITLE',
                    message: "NOTIFICATIONS.POPUP.MSG",
                    closeButton: {
                        text: "CLOSE"
                    },
                    confirmButton: {
                        text: "NOTIFICATIONS.POPUP.BTN",
                        callback: function () {
                            $location.path('/notifications');
                        }
                    }
                }).then((modal) => {
                    modal.show();
                })
            };


            /**
             * Show a popup when user tapped the notification push
             * @param data Push notification info
             */
            var showPushNotificationPopUp = function (data) {

                appi.ui.modalMessage({
                    title: data.title,
                    img: data.icon,
                    message: notificationsService.parseMessage(data.body),
                    closeButton: {
                        text: "CLOSE"
                    },
                    confirmButton: {
                        text: "NOTIFICATIONS.POPUP.BTN",
                        callback: function () {
                            $location.path('/notifications');
                        }
                    }
                }).then((modal) => {
                    modal.show();
                })
            };

            /**
             * EVENT LISTENERS
             */

            //route events
            $scope.$on("$routeChangeStart", function () {
                //if childupp is configured as 'inactive', error message should always be shown. if not, each time route changes, message is cleared.
                if (!childuppInactive) {
                    $scope.error = undefined;
                }
            });

            $scope.$on("$routeChangeSuccess", function (event, current) {
                // set a class equal that current url to the body
                var path = $location.path();
                // delete old path class
                $body.removeClass (function (index, css) {
                    return (css.match (/\bpath-\S+/g) || []).join(' ');
                });
                path = path.replace(/\//g, " path-");
                if (path === ' path-') {
                    path = 'path-index';
                }
                $body.addClass(path);

                // Update background based on route
                $rootScope.setupBackground && $rootScope.setupBackground();

                var showAd = current && current['$$route'] && current['$$route'].showAd;
                //If new route is configured to show 'ad', do it!! if not, hide ads
                if (showAd) {
                    $rootScope.enableAds && $rootScope.enableAds();
                } else {
                    $rootScope.disableAds && $rootScope.disableAds();
                }
            });

            $scope.$on("$routeChangeError", function (event, current, previous, rejection) {
                // If error cause is "inactive", should be redirected to "home".
                // This is because a module is inactive, and the user is trying to enter, so the module can't be shown.
                if (rejection === "inactive") {
                    $location.path("/");
                }
                hidePageLoadingMsg();
            });

            /**
             * INITIAL CALLINGS
             */

            // to set current year in common footer
            $scope.date = new Date();

            //register new connection to the analytics system.
            //TODO: Remove 'timeout' when possible. (phonegap library loading delay)
            if (window.location.href.indexOf('debug=true') === -1) {
                setTimeout(function () {
                    analytics.registerNewConnection();
                }, 2000);
            }

            //Check if childupp is inactive
            config.isChilduppInactive()
                .then(function (data) {
                    //Mark childupp as inactive, and show error message (hiding navbar and content)
                    showFullError({
                        desc: data.message,
                        code: data.code
                    });
                    childuppInactive = true;
                }, function (data) {
                    if (data && data.warning) {
                        console.warn(data.warning);
                    }
                });

            config.getChilduppName()
                .then(function (childuppName) {
                    var name = childuppName || $window.nameapp;
                    $rootScope.childuppName = name;
                    $window.document.title = name;
                }, function () {
                    var name = $window.nameapp;
                    $rootScope.childuppName = name;
                    $window.document.title = name;
                });

            config.getLogoPath()
                .then(function (logo) {
                    $scope.logo = logo;
                });

            config.shouldShowUppSignature()
                .then(function (show) {
                    $rootScope.showUppSignature = show === undefined ? true : show;
                }, function () {
                    $rootScope.showUppSignature = true;
                    // to show or hide Upplication signature in DOM (Footer common element)
                    $scope.showUppSignature = $rootScope.showUppSignature;
                });

            config.shouldShowAccount()
                .then(function (show) {
                    $rootScope.account = show === undefined ? false : show;

                    if ($rootScope.account) {

                        config.getCustomerAccountModule().then(function (module) {
                            $rootScope.customerAccountName = module.display;
                        });
                        // check if we want to show orders & bookins in the account
                        config.isAnActiveModule('booking').then(function () {
                            $rootScope.showBookings = true;
                        }, function () {
                            $rootScope.showBookings = false;
                        });

                        config.isAnActiveModule('cart').then(function () {
                            $rootScope.showOrders = true;
                        }, function () {
                            $rootScope.showOrders = false;
                        });

                    }
                }, function () {
                    $rootScope.account = false;
                });

            // Retrieve the notification count and show a popup if the number is greater than 0
            config.isAnActiveModule('notifications').then(function (module) {
                $rootScope.notificationsName = module.display;
                notificationsService.getUnreadCount()
                    .then(function (num) {
                        $rootScope.numNotifications = num;

                        if (num > 0) {
                            showNotificationsPopup();
                        }
                    });

                $rootScope.showNotifications = true;
            }, function () {
                $rootScope.showNotifications = false;
            });

            $rootScope.$on('event:login:authenticated', function(event, data) {
                if (data && data.principal && data.principal.userId)
                    umetadataService.storeUserId(data.principal.userId)
            });

            // Store platform on UMetaData
            const platform = determinePlatform()
            if (platform === Platform.ANDROID || platform === Platform.IOS)
                umetadataService.storePlatform(platform);
            else
                umetadataService.storePlatform('browser');


            // request permission if needed
            notifications.requestPermission();
            // Register notification callbacks
            notifications.onNotification((data) => showPushNotificationPopUp(data));
            // Register notifications tokens on the remote server (and locally)
            notifications.onTokenRefresh((token) => {
                if (token) {
                    umetadataService.storePushPlugin(notifications.name());
                    umetadataService.storeFcmToken(token);
                    storage.save('FCMToken', token);
                }
            });

            // Show notifications banner during setup process
            async function showFcmBannerIfNecessary() {
                // Show the banner and start a timer for hiding the information
                // message after some time
                $rootScope.showFCMBanner = true;
                $rootScope.showCloseInFCMBanner = false;

                // Allow the user to close the FCM banner after some time
                const timeoutId = $timeout(() => {
                    $rootScope.showCloseInFCMBanner = true;
                }, 8000);

                // Periodically check if fcm is done "configuring" for hiding
                // the banner.
                const checkToken = () => {
                    const hasPermission = notifications.hasPermission();
                    const token = notifications.getToken();
                    if (
                        // Permission has been explicitly granted and we have a valid token
                        (hasPermission === true && typeof token === 'string' && token.length > 0)
                        || // OR
                        // Permission has been explicitly revoked
                        (hasPermission === false)
                    ) {
                        $interval.cancel(intervalId);
                        $rootScope.showFCMBanner = false;
                    }
                }
                const intervalId = $interval(checkToken, 250);
                checkToken();
            }
            showFcmBannerIfNecessary();

            /**
             * PUBLIC FUNCTIONS
             */
                // Local methods  ($scope methods)
                // Can be called from this $scope
            $scope.changeLanguage = changeLanguage;

            // Global methods ($rootScope methods)
            // Can be called from everywhere
            $rootScope.showPageLoadingMsg = showPageLoadingMsg;
            $rootScope.hidePageLoadingMsg = hidePageLoadingMsg;
            $rootScope.showInlineError = showInlineError;
            $rootScope.showFullError = showFullError;
            $rootScope.showNetworkError = showNetworkError;

            $rootScope.setupBackground = function () {
                return $q.all([
                    config.isBackgroundAllApp(),
                    config.getBackground(),
                ])
                .then(function(result) {
                    var isBackgroundAllApp = result[0];
                    var backgroundUrl = result[1];
                    var isAppRoot =  $location.path() === '/';
                    if (backgroundUrl && (isBackgroundAllApp || isAppRoot)) {
                        $body.addClass('with-background');

                        var bg = {
                            'background': 'url(' + backgroundUrl + ') center center fixed no-repeat',
                            'background-size': 'cover'
                        };

                        $bg.css(bg);
                        $body.css(bg);

                        var contentsBg = { 'background': 'transparent' };
                        $wrapper.css(contentsBg);
                        $mainContainer.css(contentsBg);
                    } else {
                        setDefaultBackground();
                    }
                })
                .catch(function() { // If anything fails, fallback to default bg
                    setDefaultBackground();
                })
            };
            $rootScope.setupBackground();
        }]);

})(upp, window.jQuery);



// WEBPACK FOOTER //
// ./src/app/common/controllers/main-controller.js